import React, { useEffect, useState } from 'react';
import { Typography, TableList } from 'seagull';
import styles from "./ServiceRowPrice.module.scss";
import Decimal from 'decimal.js';
import { utils } from "../../../utils";
import { ServicePriceEditor } from "../../../components/ServicePriceEditor/ServicePriceEditor";
import { serviceModel } from "../../../models";
import { serviceTemplateModel } from "../../../models";
import { getUnitName } from "../../../utils/unit-name.utils";

function getPriceData(cost) {
  return {
    price: serviceModel.isRangePrice(cost) ? {
      minPrice: serviceModel.minPrice({
        cost
      }),
      maxPrice: serviceModel.price({
        cost
      })
    } : serviceModel.price({
      cost
    }),
    hasDiscount: serviceModel.discount({
      cost
    }) != null,
    discountedPrice: serviceModel.isRangePrice(cost) ? {
      minPrice: serviceModel.minPriceFinal({
        cost
      }),
      maxPrice: serviceModel.applyDiscount({
        cost
      })
    } : serviceModel.finalPrice({
      cost
    }, 1)
  };
}

export function ServiceRowPrice(_ref) {
  let {
    service,
    onInlineEdit,
    onInputFocus,
    onInputBlur
  } = _ref;
  const [{
    price,
    hasDiscount,
    discountedPrice
  }, setPriceData] = useState(() => getPriceData(service.cost));
  const [anchorEl, setAnchorEl] = useState(null);
  const [priceEditorOpen, setPriceEditorOpen] = useState(false);
  const isVariable = serviceTemplateModel.isVariablePrice(service.cost);
  const unitName = getUnitName(serviceTemplateModel.unitName(service), {
    short: true
  });
  const isInvalidDiscount = (isVariable || serviceTemplateModel.isRangePrice(service.cost)) && serviceTemplateModel.isValueDiscount(service.cost.discount);
  useEffect(() => {
    setPriceData(getPriceData(service.cost));
  }, [service.cost]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    "data-testid": "service-library-row-price"
  }, /*#__PURE__*/React.createElement(TableList.InlineControl.Button, {
    testid: "service-library-row-price-btn",
    error: false,
    tooltipProps: {
      title: discountedPrice == null ? '' : discountedPrice instanceof Decimal ? /*#__PURE__*/React.createElement(React.Fragment, null, utils.formatDollarAmount(discountedPrice), price instanceof Decimal && hasDiscount && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement("del", null, utils.formatDollarAmount(price))), isVariable && " / ".concat(unitName)) : /*#__PURE__*/React.createElement(React.Fragment, null, discountedPrice.minPrice instanceof Decimal && /*#__PURE__*/React.createElement(React.Fragment, null, utils.formatDollarAmount(discountedPrice.minPrice), ' - '), discountedPrice.minPrice == null && 'Up to ', discountedPrice.maxPrice instanceof Decimal ? utils.formatDollarAmount(discountedPrice.maxPrice) : '', price != null && !(price instanceof Decimal) && hasDiscount && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement("del", null, price.minPrice instanceof Decimal && /*#__PURE__*/React.createElement(React.Fragment, null, utils.formatDollarAmount(price.minPrice), ' - '), price.maxPrice instanceof Decimal ? utils.formatDollarAmount(price.maxPrice) : '')))
    },
    onClick: e => {
      setAnchorEl(e.currentTarget);
      setPriceEditorOpen(true);
      onInputFocus === null || onInputFocus === void 0 ? void 0 : onInputFocus();
    }
  }, discountedPrice == null ? /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "service-library-row-discounted-price"
  }, "________") : discountedPrice instanceof Decimal ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    "data-testid": "service-library-row-discounted-price"
  }, utils.formatDollarAmount(discountedPrice)), !isInvalidDiscount && typeof price === 'number' && hasDiscount && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    skin: "disabled",
    textDecoration: "line-through",
    "data-testid": "service-library-row-original-price"
  }, "$", utils.formatNumberWithCommas(price)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    "data-testid": "service-library-row-discounted-price"
  }, !!discountedPrice.minPrice && /*#__PURE__*/React.createElement(React.Fragment, null, utils.formatDollarAmount(discountedPrice.minPrice), ' - '), discountedPrice.minPrice == null && 'Up to ', discountedPrice.maxPrice instanceof Decimal ? utils.formatDollarAmount(discountedPrice.maxPrice) : ''), price != null && !isInvalidDiscount && !(price instanceof Decimal) && hasDiscount && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    skin: "disabled",
    textDecoration: "line-through",
    "data-testid": "service-library-row-original-price"
  }, price.minPrice instanceof Decimal && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    skin: "disabled",
    textDecoration: "line-through",
    "data-testid": "service-library-row-original-price"
  }, utils.formatDollarAmount(price.minPrice), ' - ')), "".concat(price.maxPrice instanceof Decimal ? utils.formatDollarAmount(price.maxPrice) : ''))))), isVariable && /*#__PURE__*/React.createElement(Typography, {
    className: styles.unitName,
    skin: "secondary",
    ellipsis: true,
    tooltipProps: {
      title: unitName
    }
  }, "/ ", unitName), /*#__PURE__*/React.createElement(ServicePriceEditor, {
    cost: service.cost,
    editorAnchor: anchorEl,
    isOpen: priceEditorOpen,
    setIsOpen: isOpen => {
      if (!isOpen) onInputBlur === null || onInputBlur === void 0 ? void 0 : onInputBlur();
      setPriceEditorOpen(isOpen);
    },
    onCostChange: cost => {
      setPriceData(getPriceData(cost));
      onInlineEdit({
        cost
      });
    }
  }));
}